{
  "userDetails": {
    "controls": [
      {
        "name": "isAnonymous",
        "label": "Are you submitting this report on your own behalf or on behalf of another individual?",
        "value": "",
        "type": "select",
        "options": [
          {
            "key": "I am submitting this referral on my own behalf but I wish to remain anonymous",
            "value": 1
          },
          {
            "key": "I am submitting this referral on my own behalf",
            "value": 2
          },
          {
            "key": "I am submitting this referral on behalf of another individual",
            "value": 3
          },
          {
            "key": "I am submitting this referral on behalf of another individual but they wish to remain anonymous",
            "value": 4
          }
        ],
        "validators": {
          "required": true
        },
        "helpText": "If you or the third party wish to remain anonymous, you do not have to provide your personal information. Failure to provide detailed information can impact the ability to review the report to its fullest extent."
      },
      {
        "name": "referralSource",
        "label": "Which best describes you or the individual you are submitting this report for?",
        "value": "",
        "type": "select",
        "options": [],
        "validators": {
          "required": true
        }
      },
      {
        "name": "referalIssueType",
        "label": "Select the most relevant Problem/Concern/Alleged Act Type",
        "value": "",
        "type": "select",
        "options": [],
        "validators": {
          "required": true
        }
      },
      {
        "name": "involvedType",
        "label": "Select the Suspect, Subject or Involved Party Type",
        "value": "",
        "type": "select",
        "options": [],
        "validators": {
          "required": true
        }
      },
      {
        "name": "incidentStartDt",
        "label": "Incident Start Date (i.e., First Date of Service)",
        "value": "",
        "type": "date",
        "options": {
          "min": "2000-01-01",
          "max": "2100-01-01"
        },
        "validators": {
          "required": false
        },
        "helpText": "Select the date when the incident began"
      },
      {
        "name": "incidentEndDt",
        "label": "Incident End Date (i.e., Last Date of Service)",
        "value": "",
        "type": "date",
        "options": {
          "min": "2000-01-01",
          "max": "2100-01-01"
        },
        "validators": {
          "required": false
        },
        "helpText": "End date must be the same as or after the start date"
      },
      {
        "name": "incidentState",
        "label": "State/Territory Where Incident Occurred",
        "value": "",
        "type": "select",
        "options": [],
        "validators": {
          "required": false
        }
      },
      {
        "name": "incidentCounty",
        "label": "County/District Where Incident Occurred",
        "value": "",
        "type": "select",
        "options": [],
        "validators": {
          "required": false
        }
      },
      {
        "name": "referralSummary",
        "label": "Please Provide a Summary of this Report",
        "value": "",
        "type": "textarea",
        "options": {
          "showCount": true,
          "count": 0,
          "helpText": "Please provide as much detailed information as possible. Describe any suspected fraudulent, abuse or wasteful activities, issue(s) or allegation(s). Include background, persons involved, events, specific dates and locations."
        },
        "validators": {
          "required": true,
          "maxLength": 15000
        }
      }
    ]
  },
  "contactDetails": {
    "controls": [
      {
        "name": "cdFirstName",
        "label": "First Name",
        "value": "",
        "type": "text",
        "validators": {
          "required": false
        }
      },
      {
        "name": "cdLastName",
        "label": "Last Name",
        "value": "",
        "type": "text",
        "validators": {
          "required": false
        }
      },
      {
        "name": "cdSuffix",
        "label": "Name Suffix",
        "value": "",
        "type": "text",
        "validators": {
          "required": false
        }
      },
      {
        "name": "cdTitle",
        "label": "Title",
        "value": "",
        "type": "text",
        "validators": {
          "required": false
        }
      },
      {
        "name": "cdOrgName",
        "label": "Employer/Agency/Company Name",
        "value": "",
        "type": "text",
        "validators": {
          "required": false
        }
      },
      {
        "name": "cdRelationship",
        "label": "What is your relationship to the person you are submitting this report for?",
        "value": "",
        "type": "text",
        "validators": {
          "required": false
        }
      },
      {
        "name": "cdPhone",
        "label": "Phone Number & Extension",
        "value": "",
        "type": "text",
        "options": {
          "helpText": "Must include Area Code - Add Extension # if Needed"
        },
        "validators": {
          "required": false
        }
      },
      {
        "name": "cdEmail",
        "label": "Email",
        "value": "",
        "type": "email",
        "placeholder": "",
        "validators": {
          "required": false,
          "email": true
        }
      },
      {
        "name": "cdAddress1",
        "label": "Mailing Street Address 1",
        "value": "",
        "type": "text",
        "validators": {
          "required": false,
          "maxLength": 100
        }
      },
      {
        "name": "cdAddress2",
        "label": "Mailing Street Address 2",
        "value": "",
        "type": "text",
        "validators": {
          "required": false,
          "maxLength": 50
        }
      },
      {
        "name": "cdCity",
        "label": "Mailing Address City",
        "value": "",
        "type": "text",
        "validators": {
          "required": false,
          "maxLength": 50
        }
      },
      {
        "name": "cdState",
        "label": "Mailing Address State/Territory",
        "value": "",
        "type": "select",
        "options": [],
        "validators": {
          "required": false
        }
      },
      {
        "name": "cdZip",
        "label": "Mailing Address Zip",
        "value": "",
        "type": "zip",
        "validators": {
          "required": false,
          "maxLength": 10,
          "regex": "(^[0-9]{5}$)|(^[0-9]{9}$)|(^[0-9]{5}-[0-9]{4}$)"
        }
      }
    ]
  },
  "selfReferringPartyDetails": {
    "controls": [
      {
        "name": "sepFirstName",
        "label": "First Name",
        "value": "",
        "type": "text",
        "validators": {
          "required": false
        }
      },
      {
        "name": "sepMiddleName",
        "label": "Middle Name",
        "value": "",
        "type": "text",
        "validators": {
          "required": false
        }
      },
      {
        "name": "sepLastName",
        "label": "Last Name",
        "value": "",
        "type": "text",
        "validators": {
          "required": false
        }
      },
      {
        "name": "sepSuffix",
        "label": "Name Suffix",
        "value": "",
        "type": "text",
        "validators": {
          "required": false
        }
      },
      {
        "name": "sepTitle",
        "label": "Title",
        "value": "",
        "type": "text",
        "validators": {
          "required": false
        }
      },
      {
        "name": "sepOrgName",
        "label": "Employer/Agency/Company Name",
        "value": "",
        "type": "text",
        "validators": {
          "required": false
        }
      },
      {
        "name": "sepDateOfBirth",
        "label": "Date of Birth",
        "value": "",
        "type": "date",
        "options": {
          "min": "1900-01-01",
          "max": "2100-01-01"
        },
        "validators": {
          "required": false
        }
      },
      {
        "name": "sepIdNumber",
        "label": "ID Number",
        "value": "",
        "type": "text",
        "validators": {
          "required": false
        }
      },
      {
        "name": "sepSSN",
        "label": "SSN",
        "value": "",
        "type": "ssn",
        "validators": {
          "required": false,
          "ssn":true,
          "maxLength":11
        }
      },
      {
        "name": "sepPhone",
        "label": "Phone Number",
        "value": "",
        "type": "text",
        "options": {
          "helpText": "Must include Area Code - Add Extension # if Needed"
        },
        "validators": {
          "required": false
        }
      },
      {
        "name": "sepEmail",
        "label": "Email",
        "value": "",
        "type": "email",
        "placeholder": "",
        "validators": {
          "required": false,
          "email": true
        }
      },
      {
        "name": "sepAddress1",
        "label": "Mailing Street Address 1",
        "value": "",
        "type": "text",
        "validators": {
          "required": false,
          "maxLength": 100
        }
      },
      {
        "name": "sepAddress2",
        "label": "Mailing Street Address 2",
        "value": "",
        "type": "text",
        "validators": {
          "required": false,
          "maxLength": 50
        }
      },
      {
        "name": "sepCity",
        "label": "Mailing Address City",
        "value": "",
        "type": "text",
        "validators": {
          "required": false,
          "maxLength": 50
        }
      },
      {
        "name": "sepState",
        "label": "Mailing Address State/Territory",
        "value": "",
        "type": "select",
        "options": [],
        "validators": {
          "required": false
        }
      },
      {
        "name": "sepZip",
        "label": "Mailing Address Zip",
        "value": "",
        "type": "zip",
        "validators": {
          "required": false,
          "maxLength": 10,
          "regex": "(^[0-9]{5}$)|(^[0-9]{9}$)|(^[0-9]{5}-[0-9]{4}$)"
        }
      },
      {
        "name": "sepCounty",
        "label": "Mailing Address County/District",
        "value": "",
        "type": "select",
        "options": [],
        "validators": {
          "required": false
        }
      },
      {
        "name": "sepRelationship",
        "label": "What is your relationship to the Suspect, Subject or Involved Party?",
        "value": "",
        "type": "text",
        "validators": {
          "required": false
        }
      }
    ]
  },
  "thirdPartyReferringPartyDetails": {
    "controls": [
      {
        "name": "thirdFirstName",
        "label": "First Name",
        "value": "",
        "type": "text",
        "validators": {
          "required": false
        }
      },
      {
        "name": "thirdMiddleName",
        "label": "Middle Name",
        "value": "",
        "type": "text",
        "validators": {
          "required": false
        }
      },
      {
        "name": "thirdLastName",
        "label": "Last Name",
        "value": "",
        "type": "text",
        "validators": {
          "required": false
        }
      },
      {
        "name": "thirdSuffix",
        "label": "Name Suffix",
        "value": "",
        "type": "text",
        "validators": {
          "required": false
        }
      },
      {
        "name": "thirdTitle",
        "label": "Title",
        "value": "",
        "type": "text",
        "validators": {
          "required": false
        }
      },
      {
        "name": "thirdOrgName",
        "label": "Employer/Agency/Company Name",
        "value": "",
        "type": "text",
        "validators": {
          "required": false
        }
      },
      {
        "name": "thirdDateOfBirth",
        "label": "Date of Birth",
        "value": "",
        "type": "date",
        "options": {
          "min": "1900-01-01",
          "max": "2100-01-01"
        },
        "validators": {
          "required": false
        }
      },
      {
        "name": "thirdIdNumber",
        "label": "ID Number",
        "value": "",
        "type": "text",
        "validators": {
          "required": false
        }
      },
      {
        "name": "thirdSSN",
        "label": "SSN",
        "value": "",
        "type": "ssn",
        "validators": {
          "required": false,
          "ssn":true,
          "maxLength":11
        }
      },
      {
        "name": "thirdPhone",
        "label": "Phone Number",
        "value": "",
        "type": "text",
        "options": {
          "helpText": "Must include Area Code - Add Extension # if Needed"
        },
        "validators": {
          "required": false
        }
      },
      {
        "name": "thirdEmail",
        "label": "Email",
        "value": "",
        "type": "email",
        "placeholder": "",
        "validators": {
          "required": false,
          "email": true
        }
      },
      {
        "name": "thirdAddress1",
        "label": "Mailing Street Address 1",
        "value": "",
        "type": "text",
        "validators": {
          "required": false,
          "maxLength": 100
        }
      },
      {
        "name": "thirdAddress2",
        "label": "Mailing Street Address 2",
        "value": "",
        "type": "text",
        "validators": {
          "required": false,
          "maxLength": 50
        }
      },
      {
        "name": "thirdCity",
        "label": "Mailing Address City",
        "value": "",
        "type": "text",
        "validators": {
          "required": false,
          "maxLength": 50
        }
      },
      {
        "name": "thirdState",
        "label": "Mailing Address State/Territory",
        "value": "",
        "type": "select",
        "options": [],
        "validators": {
          "required": false
        }
      },
      {
        "name": "thirdZip",
        "label": "Mailing Address Zip",
        "value": "",
        "type": "zip",
        "validators": {
          "required": false,
          "maxLength": 10,
          "regex": "(^[0-9]{5}$)|(^[0-9]{9}$)|(^[0-9]{5}-[0-9]{4}$)"
        }
      },
      {
        "name": "thirdCounty",
        "label": "Mailing Address County/District",
        "value": "",
        "type": "select",
        "options": [],
        "validators": {
          "required": false
        }
      },
      {
        "name": "thirdRelationship",
        "label": "What is your relationship to the Suspect, Subject or Involved Party?",
        "value": "",
        "type": "text",
        "validators": {
          "required": false
        }
      }
    ]
  },
  "individualReferringPartyDetails": {
    "controls": [
      {
        "name": "indFirstName",
        "label": "First Name",
        "value": "",
        "type": "text",
        "validators": {
          "required": false
        }
      },
      {
        "name": "indLastName",
        "label": "Last Name",
        "value": "",
        "type": "text",
        "validators": {
          "required": false
        }
      },
      {
        "name": "indSuffix",
        "label": "Name Suffix",
        "value": "",
        "type": "text",
        "validators": {
          "required": false
        }
      },
      {
        "name": "indTitle",
        "label": "Title",
        "value": "",
        "type": "text",
        "validators": {
          "required": false
        }
      },
      {
        "name": "indOrgName",
        "label": "Employer/Agency/Company Name",
        "value": "",
        "type": "text",
        "validators": {
          "required": false
        }
      },
      {
        "name": "indRelationship",
        "label": "What is your relationship to the person you are submitting this report for?",
        "value": "",
        "type": "text",
        "validators": {
          "required": false
        }
      },
      {
        "name": "indPhone",
        "label": "Phone Number",
        "value": "",
        "type": "text",
        "options": {
          "helpText": "Must include Area Code - Add Extension # if Needed"
        },
        "validators": {
          "required": false
        }
      },
      {
        "name": "indEmail",
        "label": "Email",
        "value": "",
        "type": "email",
        "placeholder": "",
        "validators": {
          "required": false,
          "email": true
        }
      },
      {
        "name": "indAddress1",
        "label": "Mailing Street Address 1",
        "value": "",
        "type": "text",
        "validators": {
          "required": false,
          "maxLength": 100
        }
      },
      {
        "name": "indAddress2",
        "label": "Mailing Street Address 2",
        "value": "",
        "type": "text",
        "validators": {
          "required": false,
          "maxLength": 50
        }
      },
      {
        "name": "indCity",
        "label": "Mailing Address City",
        "value": "",
        "type": "text",
        "validators": {
          "required": false,
          "maxLength": 50
        }
      },
      {
        "name": "indState",
        "label": "Mailing Address State/Territory",
        "value": "",
        "type": "select",
        "options": [],
        "validators": {
          "required": false
        }
      },
      {
        "name": "indZip",
        "label": "Mailing Address Zip",
        "value": "",
        "type": "zip",
        "validators": {
          "required": false,
          "maxLength": 10,
          "regex": "(^[0-9]{5}$)|(^[0-9]{9}$)|(^[0-9]{5}-[0-9]{4}$)"
        }
      }
    ]
  },
  "memberDetails": {
    "controls": [
      {
        "name": "mFirstName",
        "label": "First Name",
        "value": "",
        "type": "text",
        "validators": {
          "required": false,
          "maxLength": 100
        }
      },
      {
        "name": "mMiddleName",
        "label": "Middle Name",
        "value": "",
        "type": "text",
        "validators": {
          "required": false,
          "maxLength": 50
        }
      },
      {
        "name": "mLastName",
        "label": "Last Name",
        "value": "",
        "type": "text",
        "validators": {
          "required": false,
          "maxLength": 100
        }
      },
      {
        "name": "mNameSuffix",
        "label": "Name Suffix",
        "value": "",
        "type": "text",
        "validators": {
          "required": false,
          "maxLength": 50
        }
      },
      {
        "name": "mDateOfBirth",
        "label": "Date of Birth",
        "value": "",
        "type": "date",
        "options": {
          "min": "1900-01-01",
          "max": "2100-01-01"
        },
        "validators": {
          "required": false
        }
      },
      {
        "name": "mGender",
        "label": "Gender",
        "value": "",
        "type": "text",
        "validators": {
          "required": false,
          "maxLength": 50
        }
      },
      {
        "name": "mOther",
        "label": "Other",
        "value": "",
        "type": "text",
        "validators": {
          "required": false,
          "maxLength": 100
        }
      },
      {
        "name": "mID",
        "label": "ID",
        "value": "",
        "type": "text",
        "validators": {
          "required": false,
          "maxLength": 100
        }
      },
      {
        "name": "mSSN",
        "label": "SSN",
        "value": "",
        "type": "ssn",
        "validators": {
          "required": false,
          "ssn": true,
          "maxLength": 11
        }
      },
      {
        "name": "mAddress1",
        "label": "Street Address 1",
        "value": "",
        "type": "text",
        "validators": {
          "required": false,
          "maxLength": 100
        }
      },
      {
        "name": "mAddress2",
        "label": "Street Address 2",
        "value": "",
        "type": "text",
        "validators": {
          "required": false,
          "maxLength": 100
        }
      },
      {
        "name": "mCity",
        "label": "City",
        "value": "",
        "type": "text",
        "validators": {
          "required": false,
          "maxLength": 50
        }
      },
      {
        "name": "mState",
        "label": "State/Territory",
        "value": "",
        "type": "select",
        "validators": {
          "required": false
        }
      },
      {
        "name": "mCounty",
        "label": "County",
        "value": "",
        "type": "select",
        "validators": {
          "required": false
        }
      },
      {
        "name": "mZip",
        "label": "Zip Code",
        "value": "",
        "type": "zip",
        "placeholder": "99999",
        "validators": {
          "required": false,
          "regex": "(^[0-9]{5}$)|(^[0-9]{9}$)|(^[0-9]{5}-[0-9]{4}$)",
          "maxLength": 10
        }
      },
      {
        "name": "mPrimaryPhone",
        "label": "Primary Phone",
        "value": "",
        "type": "text",
        "placeholder": "999-999-9999",
        "validators": {
          "required": false,
          "maxLength": 50
        }
      },
      {
        "name": "mEmail",
        "label": "Email",
        "value": "",
        "type": "email",
        "validators": {
          "required": false,
          "email": true,
          "maxLength": 100
        }
      }
    ]
  },
  "providerDetails": {
    "controls": [
      {
        "name": "pOrgName",
        "label": "Organization/Company Name",
        "value": "",
        "type": "text",
        "validators": {
          "required": false,
          "maxLength": 150
        }
      },
      {
        "name": "pFirstName",
        "label": "First Name",
        "value": "",
        "type": "text",
        "validators": {
          "required": false,
          "maxLength": 100
        }
      },
      {
        "name": "pLastName",
        "label": "Last Name",
        "value": "",
        "type": "text",
        "validators": {
          "required": false,
          "maxLength": 100
        }
      },
      {
        "name": "pNameSuffix",
        "label": "Name Suffix",
        "value": "",
        "type": "text",
        "validators": {
          "required": false,
          "maxLength": 50
        }
      },
      {
        "name": "pDesignation",
        "label": "Designation/Title",
        "value": "",
        "type": "text",
        "validators": {
          "required": false,
          "maxLength": 100
        }
      },
      {
        "name": "pManualSubjectID",
        "label": "ID",
        "value": "",
        "type": "text",
        "validators": {
          "required": false,
          "maxLength": 100
        }
      },
      {
        "name": "pNPI",
        "label": "NPI",
        "value": "",
        "type": "text",
        "validators": {
          "required": false,
          "maxLength": 10
        }
      },
      {
        "name": "pTIN",
        "label": "TIN/EIN",
        "value": "",
        "type": "text",
        "validators": {
          "required": false,
          "maxLength": 11
        }
      },
      {
        "name": "pLicenseNo",
        "label": "License Number",
        "value": "",
        "type": "text",
        "validators": {
          "required": false,
          "maxLength": 50
        }
      },
      {
        "name": "pStreetAddress1",
        "label": "Street Address1",
        "value": "",
        "type": "text",
        "validators": {
          "required": false,
          "maxLength": 100
        }
      },
      {
        "name": "pStreetAddress2",
        "label": "Street Address2",
        "value": "",
        "type": "text",
        "validators": {
          "required": false,
          "maxLength": 100
        }
      },
      {
        "name": "pCity",
        "label": "City",
        "value": "",
        "type": "text",
        "validators": {
          "required": false,
          "maxLength": 50
        }
      },
      {
        "name": "pState",
        "label": "State/Territory",
        "value": "",
        "type": "select",
        "validators": {
          "required": false
        }
      },
      {
        "name": "pCounty",
        "label": "County/District",
        "value": "",
        "type": "select",
        "validators": {
          "required": false
        }
      },
      {
        "name": "pZip",
        "label": "Zip Code",
        "value": "",
        "type": "zip",
        "placeholder": "99999",
        "validators": {
          "required": false,
          "regex": "(^[0-9]{5}$)|(^[0-9]{9}$)|(^[0-9]{5}-[0-9]{4}$)",
          "maxLength": 10
        }
      },
      {
        "name": "pCountry",
        "label": "Country",
        "value": "",
        "type": "text",
        "validators": {
          "required": false,
          "maxLength": 100
        }
      },
      {
        "name": "pPhone",
        "label": "Phone",
        "value": "",
        "type": "text",
        "placeholder": "999-999-9999",
        "validators": {
          "required": false,
          "maxLength": 50
        }
      },
      {
        "name": "pEmail",
        "label": "Email",
        "value": "",
        "type": "email",
        "validators": {
          "email": true,
          "required": false,
          "maxLength": 100
        }
      }
    ]
  },
  "nonEnumeratedProviderDetails": {
    "controls": [
      {
        "name": "nepOrgName",
        "label": "Organization/Company Name",
        "value": "",
        "type": "text",
        "validators": {
          "required": false,
          "maxLength": 100
        }
      },
      {
        "name": "nepFirstName",
        "label": "First Name",
        "value": "",
        "type": "text",
        "validators": {
          "required": false,
          "maxLength": 100
        }
      },
      {
        "name": "nepMiddleName",
        "label": "Middle Name",
        "value": "",
        "type": "text",
        "validators": {
          "required": false,
          "maxLength": 50
        }
      },
      {
        "name": "nepLastName",
        "label": "Last Name",
        "value": "",
        "type": "text",
        "validators": {
          "required": false,
          "maxLength": 100
        }
      },
      {
        "name": "nepNameSuffix",
        "label": "Name Suffix",
        "value": "",
        "type": "text",
        "validators": {
          "required": false,
          "maxLength": 50
        }
      },
      {
        "name": "nepDesignation",
        "label": "Designation/Title",
        "value": "",
        "type": "text",
        "validators": {
          "required": false,
          "maxLength": 100
        }
      },
      {
        "name": "nepSsn",
        "label": "SSN",
        "value": "",
        "type": "ssn",
        "validators": {
          "required": false,
          "ssn": true,
          "maxLength": 11
        }
      },
      {
        "name": "nepLicenseNo",
        "label": "License Number",
        "value": "",
        "type": "text",
        "validators": {
          "required": false,
          "maxLength": 100
        }
      },
      {
        "name": "nepOther",
        "label": "Other",
        "value": "",
        "type": "text",
        "validators": {
          "required": false,
          "maxLength": 100
        }
      },
      {
        "name": "nepPrimaryPhone",
        "label": "Primary Phone",
        "value": "",
        "type": "text",
        "placeholder": "999-999-9999",
        "validators": {
          "required": false,
          "maxLength": 50
        }
      },
      {
        "name": "nepEmail",
        "label": "Email",
        "value": "",
        "type": "email",
        "validators": {
          "email": true,
          "required": false,
          "maxLength": 100
        }
      },
      {
        "name": "nepStreetAddress1",
        "label": "Street Address1",
        "value": "",
        "type": "text",
        "validators": {
          "required": false,
          "maxLength": 100
        }
      },
      {
        "name": "nepStreetAddress2",
        "label": "Street Address2",
        "value": "",
        "type": "text",
        "validators": {
          "required": false,
          "maxLength": 100
        }
      },
      {
        "name": "nepCity",
        "label": "City",
        "value": "",
        "type": "text",
        "validators": {
          "required": false,
          "maxLength": 50
        }
      },
      {
        "name": "nepState",
        "label": "State/Territory",
        "value": "",
        "type": "select",
        "validators": {
          "required": false
        }
      },
      {
        "name": "nepCounty",
        "label": "County/District",
        "value": "",
        "type": "select",
        "validators": {
          "required": false
        }
      },
      {
        "name": "nepZip",
        "label": "Zip",
        "value": "",
        "type": "zip",
        "placeholder": "99999",
        "validators": {
          "required": false,
          "maxLength": 10,
          "regex": "(^[0-9]{5}$)|(^[0-9]{9}$)|(^[0-9]{5}-[0-9]{4}$)"
        }
      },
      {
        "name": "nepCountry",
        "label": "Country",
        "value": "",
        "type": "text",
        "validators": {
          "required": false,
          "maxLength": 100
        }
      }
    ]
  },
  "nonEnumeratedOrganizationDetails": {
    "controls": [
      {
        "name": "neoOrgName",
        "label": "Organization Name",
        "value": "",
        "type": "text",
        "validators": {
          "required": false,
          "maxLength": 100
        }
      },
      {
        "name": "neoTIN",
        "label": "TIN/EIN",
        "value": "",
        "type": "text",
        "validators": {
          "required": false,
          "maxLength": 11
        }
      },
      {
        "name": "neoLicenseNo",
        "label": "License Number",
        "value": "",
        "type": "text",
        "validators": {
          "required": false,
          "maxLength": 50
        }
      },
      {
        "name": "neoOther",
        "label": "Other",
        "value": "",
        "type": "text",
        "validators": {
          "required": false,
          "maxLength": 100
        }
      },
      {
        "name": "neoOtherId",
        "label": "Other ID",
        "value": "",
        "type": "text",
        "validators": {
          "required": false,
          "maxLength": 50
        }
      },
      {
        "name": "neoContactNamePrefix",
        "label": "Contact Name Prefix",
        "value": "",
        "type": "text",
        "validators": {
          "required": false,
          "maxLength": 50
        }
      },
      {
        "name": "neoContactFirstName",
        "label": "Contact First Name",
        "value": "",
        "type": "text",
        "validators": {
          "required": false,
          "maxLength": 100
        }
      },
      {
        "name": "neoContactMiddleName",
        "label": "Contact Middle Name",
        "value": "",
        "type": "text",
        "validators": {
          "required": false,
          "maxLength": 50
        }
      },
      {
        "name": "neoContactLastName",
        "label": "Contact Last Name",
        "value": "",
        "type": "text",
        "validators": {
          "required": false,
          "maxLength": 100
        }
      },
      {
        "name": "neoContactDesignation",
        "label": "Contact Designation/Title",
        "value": "",
        "type": "text",
        "validators": {
          "required": false,
          "maxLength": 100
        }
      },
      {
        "name": "neoPhone",
        "label": "Phone",
        "value": "",
        "type": "text",
        "placeholder": "999-999-9999",
        "validators": {
          "required": false,
          "maxLength": 50
        }
      },
      {
        "name": "neoEmail",
        "label": "Email",
        "value": "",
        "type": "email",
        "validators": {
          "required": false,
          "email": true,
          "maxLength": 100
        }
      },
      {
        "name": "neoStreetAddress1",
        "label": "Street Address1",
        "value": "",
        "type": "text",
        "validators": {
          "maxLength": 100,
          "required": false
        }
      },
      {
        "name": "neoStreetAddress2",
        "label": "Street Address2",
        "value": "",
        "type": "text",
        "validators": {
          "required": false,
          "maxLength": 100
        }
      },
      {
        "name": "neoCity",
        "label": "City",
        "value": "",
        "type": "text",
        "validators": {
          "required": false,
          "maxLength": 50
        }
      },
      {
        "name": "neoState",
        "label": "State/Territory",
        "value": "",
        "type": "select",
        "validators": {
          "required": false
        }
      },
      {
        "name": "neoCounty",
        "label": "County/District",
        "value": "",
        "type": "select",
        "validators": {
          "required": false
        }
      },
      {
        "name": "neoZip",
        "label": "Zip",
        "value": "",
        "type": "zip",
        "placeholder": "99999",
        "validators": {
          "required": false,
          "maxLength": 10,
          "regex": "(^[0-9]{5}$)|(^[0-9]{9}$)|(^[0-9]{5}-[0-9]{4}$)"
        }
      },
      {
        "name": "neoCountry",
        "label": "Country",
        "value": "",
        "type": "text",
        "validators": {
          "required": false,
          "maxLength": 100
        }
      }
    ]
  },
  "nonEnumeratedIndividualDetails": {
    "controls": [
      {
        "name": "neiNamePrefix",
        "label": "Name Prefix",
        "value": "",
        "type": "text",
        "validators": {
          "required": false,
          "maxLength": 50
        }
      },
      {
        "name": "neiFirstName",
        "label": "First Name",
        "value": "",
        "type": "text",
        "validators": {
          "required": false,
          "maxLength": 100
        }
      },
      {
        "name": "neiMiddleName",
        "label": "Middle Name",
        "value": "",
        "type": "text",
        "validators": {
          "required": false,
          "maxLength": 50
        }
      },
      {
        "name": "neiLastName",
        "label": "Last Name",
        "value": "",
        "type": "text",
        "validators": {
          "required": false,
          "maxLength": 100
        }
      },
      {
        "name": "neiNameSuffix",
        "label": "Name Suffix",
        "value": "",
        "type": "text",
        "validators": {
          "required": false,
          "maxLength": 50
        }
      },
      {
        "name": "neiDesignation",
        "label": "Designation/Title",
        "value": "",
        "type": "text",
        "validators": {
          "required": false,
          "maxLength": 100
        }
      },
      {
        "name": "neiDateOfBirth",
        "label": "Date Of Birth",
        "value": "",
        "type": "date",
        "options": {
          "min": "1900-01-01",
          "max": "2100-01-01"
        },
        "validators": {
          "required": false
        }
      },
      {
        "name": "neiOther",
        "label": "Other",
        "value": "",
        "type": "text",
        "validators": {
          "required": false,
          "maxLength": 100
        }
      },
      {
        "name": "neiPrimaryPhone",
        "label": "Primary Phone",
        "value": "",
        "type": "text",
        "placeholder": "999-999-9999",
        "validators": {
          "required": false,
          "maxLength": 50
        }
      },
      {
        "name": "neiEmail",
        "label": "Email",
        "value": "",
        "type": "email",
        "validators": {
          "required": false,
          "maxLength": 100,
          "email": true
        }
      },
      {
        "name": "neiStreetAddress1",
        "label": "Street Address1",
        "value": "",
        "type": "text",
        "validators": {
          "required": false,
          "maxLength": 100
        }
      },
      {
        "name": "neiStreetAddress2",
        "label": "Street Address2",
        "value": "",
        "type": "text",
        "validators": {
          "required": false,
          "maxLength": 100
        }
      },
      {
        "name": "neiCity",
        "label": "City",
        "value": "",
        "type": "text",
        "validators": {
          "required": false,
          "maxLength": 50
        }
      },
      {
        "name": "neiState",
        "label": "State/Territory",
        "value": "",
        "type": "select",
        "validators": {
          "required": false
        }
      },
      {
        "name": "neiCounty",
        "label": "County/District",
        "value": "",
        "type": "select",
        "validators": {
          "required": false
        }
      },
      {
        "name": "neiZip",
        "label": "Zip Code",
        "value": "",
        "type": "zip",
        "placeholder": "99999",
        "validators": {
          "required": false,
          "regex": "(^[0-9]{5}$)|(^[0-9]{9}$)|(^[0-9]{5}-[0-9]{4}$)",
          "maxLength": 10
        }
      }
    ]
  }
}